import { useLocation as useRouterLocation } from 'react-router-dom';
export function useLocation() {
    var _a = useRouterLocation(), pathname = _a.pathname, search = _a.search, hash = _a.hash;
    return { pathname: pathname, search: search, hash: hash };
}
